import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class TruckAllocation extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs:[],
            objsload:false,
            assign:"-1",

            vehcapcity:'',
            vehtype:'',
            vehtname:'',
            traplate:'',
            driname:'',
            drilicno:'',
            drilicvalid:'',
            driphone:'',
            origin:"-1",
            des:"-1",
            isroutefound:false,
            distance:'',
            fuelempty:'',
            fuelload:'',
            perdiemempty:'',
            allowancloaded:'',
            handlinefeeempty:'',
            handlinefeeloaded:'',
            orderdate:'',
            dateofallocation:'',
            dateofarivalatloadpoint:'',
            dateofloading:'',
            dateofdeparture:'',
            dateofarivalatboarder:'',
            dateofarivalatoffloadpoint:'',
            client:'',
            cargo_id:"-1",
            loadpoint_id:"-1",
            maxpayload:'',
            rateperquntal:'',
            revbirr:'',
            fuelatorgin:'',
            fuelcost:'',
            perdium:'',
            handling:'',
            otherexpense:'',
            supervisor:'',
        }
    }
    async componentDidMount() {
        let baseurl = myconfig.getobject;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        await axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs:res.data,
                    objsload:true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }
    vehiclemgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        let vehcapcity=''
        let vehtype=''
        let vehtname=''
        let traplate=''
        let driname=''
        let drilicno=''
        let drilicvalid=''
        let driphone=''
        let temp=this.state.objs.retvehicles.find(o=>o.id==value)
        if(temp!==undefined)
        {
            vehcapcity=temp.capacity
            vehtype=temp.type
            vehtname=temp.tname
        }
        temp=this.state.objs.rettrailes.find(o=>o.id==value)
        if(temp!==undefined)
        {
            traplate=temp.plateno
        }
        this.setState({
            [name]: value,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
        })

        temp=this.state.objs.retdrivers.find(o=>o.id==value)
        if(temp!==undefined)
        {
            driname=temp.name
            drilicno=temp.licenceno
            drilicvalid=temp.licencevalidty
            driphone=temp.phoneno
        }
        this.setState({
            [name]: value,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
        })

    }
    routemgt =(event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        },()=>this.routefetch())
    }
    btnnew =(event) => {
        event.preventDefault();
        this.setState({
            assign:"-1",
            vehcapcity:'',
            vehtype:'',
            vehtname:'',
            traplate:'',
            driname:'',
            drilicno:'',
            drilicvalid:'',
            driphone:'',
            origin:"-1",
            des:"-1",
            distance:'',
            fuelempty:'',
            fuelload:'',
            perdiemempty:'',
            allowancloaded:'',
            handlinefeeempty:'',
            handlinefeeloaded:'',
            orderdate:'',
            dateofallocation:'',
            dateofarivalatloadpoint:'',
            dateofloading:'',
            dateofdeparture:'',
            dateofarivalatboarder:'',
            dateofarivalatoffloadpoint:'',
            client:'',
            cargo_id:"-1",
            loadpoint_id:"-1",
            maxpayload:'',
            rateperquntal:'',
            revbirr:'',
            fuelatorgin:'',
            fuelcost:'',
            perdium:'',
            handling:'',
            otherexpense:'',
            isroutefound:false,
            supervisor:'',
        })
    }
    btnsave =async (event) => {
        event.preventDefault();
        if (this.state.assign == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select truck",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.origin == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select Orgin",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.des == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select Destination",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (!this.state.isroutefound)
            Swal.fire({
                title: 'Error!',
                text: "Route is not found",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.orderdate == '')
            Swal.fire({
                title: 'Error!',
                text: "Order date is requred",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.cargo_id == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select cargo",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (this.state.loadpoint_id == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select load point",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (isNaN(this.state.maxpayload) || this.state.maxpayload == "")
            Swal.fire({
                title: 'Error!',
                text: "Max pay load must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (isNaN(this.state.rateperquntal) || this.state.rateperquntal == "")
            Swal.fire({
                title: 'Error!',
                text: "Transport per quntal must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (isNaN(this.state.fuelatorgin) || this.state.fuelatorgin == "")
            Swal.fire({
                title: 'Error!',
                text: "Fuel at origin must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (isNaN(this.state.handling) || this.state.handling == "")
            Swal.fire({
                title: 'Error!',
                text: "Handling cost must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })

        else if (isNaN(this.state.perdium) || this.state.perdium == "")
            Swal.fire({
                title: 'Error!',
                text: "Pre Dime cost must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else {
            let baseurl = myconfig.createallocation;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            await axios.post(baseurl, {
                "sid": sid,
                "assignment_id": this.state.assign,
                "org": this.state.origin,
                "des": this.state.des,
                "orderdate": this.state.orderdate,
                "dateofallocation": this.state.dateofallocation,
                "dateofarivalatloadpoint": this.state.dateofarivalatloadpoint,
                "dateofloading": this.state.dateofloading,
                "dateofdeparture": this.state.dateofdeparture,
                "dateofarivalatboarder": this.state.dateofarivalatboarder,
                "dateofarivalatoffloadpoint": this.state.dateofarivalatoffloadpoint,
                "client": this.state.client,
                "cargo_id": this.state.cargo_id,
                "loadpoint_id": this.state.loadpoint_id,
                "maxpayload": this.state.maxpayload,
                "rateperquntal": this.state.rateperquntal,
                "revbirr": this.state.revbirr,
                "fuelatorgin": this.state.fuelatorgin,
                "fuelcost": this.state.fuelcost,
                "perdium": this.state.perdium,
                "handling": this.state.handling,
                "otherexpense": this.state.otherexpense,
                "supervisor": this.state.supervisor,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {

                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    routefetch=async ()=> {
        let distance = 'NA'
        let fuelempty = 'NA'
        let fuelload = 'NA'
        let perdiemempty = 'NA'
        let allowancloaded = 'NA'
        let handlinefeeempty = 'NA'
        let handlinefeeloaded = 'NA'
        let isroutefound=false
        if (this.state.org != "-1" && this.state.des != "-1") {
            let baseurl = myconfig.checkroute;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            await axios.post(baseurl, {
                "sid": sid,
                "org": this.state.origin,
                "des": this.state.des,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    if (res.data.isfound) {
                        isroutefound=true
                        distance = res.data.distance
                        fuelempty = res.data.fuelempty
                        fuelload = res.data.fuelload
                        perdiemempty = res.data.perdiemempty
                        allowancloaded = res.data.allowancloaded
                        handlinefeeempty = res.data.handlinefeeempty
                        handlinefeeloaded = res.data.handlinefeeloaded
                    }
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        this.setState({
            distance: distance,
            fuelempty: fuelempty,
            fuelload: fuelload,
            perdiemempty: perdiemempty,
            allowancloaded: allowancloaded,
            handlinefeeempty: handlinefeeempty,
            handlinefeeloaded: handlinefeeloaded,
            isroutefound:isroutefound,
        })
    }

    combovehicle=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.retvehicles.map(value => {
                return (<option value={value.id}>{value.plateno}</option>)
            })
            retdata = <select className="form-control" value={this.state.assign} name="assign" onChange={this.vehiclemgt}>
                <option value="-1">--Select Vehicle--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }
    combocargo=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.cargos.map(value => {
                return (<option value={value.id}>{value.name}</option>)
            })
            retdata = <select className="form-control" value={this.state.cargo_id} name="cargo_id" onChange={this.inputmgt}>
                <option value="-1">--Select Cargo--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }
    comboloadpoint=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.loadpoints.map(value => {
                return (<option value={value.id}>{value.name}</option>)
            })
            retdata = <select className="form-control" value={this.state.loadpoint_id} name="loadpoint_id" onChange={this.inputmgt}>
                <option value="-1">--Select Loading Point--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }
    comboorg=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.retroutes.map(value => {
                return (<option value={value.loc}>{value.loc}</option>)
            })
            retdata = <select className="form-control" value={this.state.origin} name="origin" onChange={this.routemgt}>
                <option value="-1">--Select Origin--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }
    combodes=()=> {
        let retdata = null;
        if (this.state.objsload) {
            let optiondata = this.state.objs.retroutes.map(value => {
                return (<option value={value.loc}>{value.loc}</option>)
            })
            retdata = <select className="form-control" value={this.state.des} name="des" onChange={this.routemgt}>
                <option value="-1">--Select Destination--</option>
                {optiondata}
            </select>
        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    render() {
        return (
            <>
                <div className={this.state.menu}>
                    <Nav/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav
                            className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky "
                            id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a
                                            className="opacity-5 text-white" href="#">Operation</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">Truck-Allocation</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white"/>
                                            <i className="sidenav-toggler-line bg-white"/>
                                            <i className="sidenav-toggler-line bg-white"/>
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search"
                                                                                            aria-hidden="true"/></span>
                                            <input type="text" className="form-control" placeholder="Type here..."/>
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="../../pages/authentication/signin/illustration.html"
                                               className="nav-link text-white font-weight-bold px-0" target="_blank">
                                                <i className="fa fa-user me-sm-1"/>
                                                <span className="d-sm-inline d-none">Sign In</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" id="iconNavbarSidenav">
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                    <i className="sidenav-toggler-line bg-white"/>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h4 className="text-white">Create a new allocation</h4>
                                        <p className="text-white opacity-8">Here you can create a new truck allocation.</p>
                                    </div>
                                    <div className="col-lg-6 text-right d-flex flex-column justify-content-center">
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-lg-5">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="font-weight-bolder">Truck Information</h5>
                                                <div className="row">
                                                    <div className="col-12 col-sm-6">
                                                        <label>Truck</label>
                                                        {this.combovehicle()}
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Capacity</label>
                                                        <input disabled className="form-control" type="number" value={this.state.vehcapcity} name="vehcapcity" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Type</label>
                                                        <input disabled className="form-control" type="text" value={this.state.vehtype} name="vehtype" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Transporter</label>
                                                        <input disabled className="form-control" type="text" value={this.state.vehtname} name="vehtname" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Trailer</label>
                                                        <input disabled className="form-control" type="text" value={this.state.traplate} name="traplate" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Driver</label>
                                                        <input disabled className="form-control" type="text" value={this.state.driname} name="driname" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Licence #</label>
                                                        <input disabled className="form-control" type="text" value={this.state.drilicno} name="drilicno" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Licence Validity</label>
                                                        <input disabled className="form-control" type="date" value={this.state.drilicvalid} name="drilicvalid" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Phone #</label>
                                                        <input disabled className="form-control" type="text" value={this.state.driphone} name="driphone" onChange={this.inputmgt}/>
                                                    </div>
                                                </div>
                                                <h5 className="font-weight-bolder pt-5">Route Information</h5>
                                                <div className="row">
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Origin</label>
                                                        {this.comboorg()}
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Destination</label>
                                                        {this.combodes()}
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>DISTANCE</label>
                                                        <input disabled className="form-control" type="text" name="distance" onChange={this.inputmgt} value={this.state.distance}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>FUEL-EMPTY</label>
                                                        <input disabled className="form-control" type="text" name="fuelempty" onChange={this.inputmgt} value={this.state.fuelempty}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>FUEL-LOADED</label>
                                                        <input disabled className="form-control" type="text" name="fuelload" onChange={this.inputmgt} value={this.state.fuelload}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>PER DIEM</label>
                                                        <input disabled className="form-control" type="text" name="perdiemempty" onChange={this.inputmgt} value={this.state.perdiemempty}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>ALLOWANCE</label>
                                                        <input disabled className="form-control" type="text" name="allowancloaded" onChange={this.inputmgt} value={this.state.allowancloaded}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>HANDLING FEES Empty</label>
                                                        <input disabled className="form-control" type="text" name="handlinefeeempty" onChange={this.inputmgt} value={this.state.handlinefeeempty}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>HANDLING FEES Loaded</label>
                                                        <input disabled className="form-control" type="text" name="handlinefeeloaded" onChange={this.inputmgt} value={this.state.handlinefeeloaded}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 mt-lg-0 mt-4">
                                        <div className="card h-100">
                                            <div className="card-body">
                                                <h5 className="font-weight-bolder">Truck Allocation</h5>
                                                <div className="row">
                                                    <div className="col-12 col-sm-6">
                                                        <label>Order</label>
                                                        <input name="orderdate" value={this.state.orderdate} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Allocation</label>
                                                        <input name="dateofallocation" value={this.state.dateofallocation} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Arrival Loading</label>
                                                        <input name="dateofarivalatloadpoint" value={this.state.dateofarivalatloadpoint} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Loading</label>
                                                        <input name="dateofloading" value={this.state.dateofloading} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Departure</label>
                                                        <input name="dateofdeparture" value={this.state.dateofdeparture} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Arrival at boarder</label>
                                                        <input name="dateofarivalatboarder" value={this.state.dateofarivalatboarder} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Departure at boarder</label>
                                                        <input name="dateofdepartureatboarder" value={this.state.dateofdepartureatboarder} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Arrival offloading</label>
                                                        <input name="dateofarivalatoffloadpoint" value={this.state.dateofarivalatoffloadpoint} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                        <label>Offloading</label>
                                                        <input name="dateofarivalatoffloadpoint" value={this.state.dateofarivalatoffloadpoint} className="form-control" type="date" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6">
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Client</label>
                                                        <input name="client" value={this.state.client} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Cargo</label>
                                                        {this.combocargo()}
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Loading Point</label>
                                                        {this.comboloadpoint()}
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Supervisor</label>
                                                        <input name="supervisor" value={this.state.supervisor} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Max Payload</label>
                                                        <input name="maxpayload" value={this.state.maxpayload} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Transport / Quntal</label>
                                                        <input name="rateperquntal" value={this.state.rateperquntal} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Fuel Orgin</label>
                                                        <input name="fuelatorgin" value={this.state.fuelatorgin} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Cost</label>
                                                        <input disabled name="fuelcost" value={this.state.fuelcost} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Revenue birr</label>
                                                        <input disabled name="revbirr" value={this.state.revbirr} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Perdium</label>
                                                        <input name="perdium" value={this.state.perdium} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Handling</label>
                                                        <input name="handling" value={this.state.handling} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                                                        <label>Any other cost</label>
                                                        <input name="otherexpense" value={this.state.otherexpense} className="form-control" type="text" onChange={this.inputmgt}/>
                                                    </div>
                                                </div>

                                                <div className="row pt-3">
                                                    <div className="col-sm-6">

                                                    </div>
                                                    <div className="col-sm-6 d-flex justify-content-between">
                                                        <button className="btn btn-block btn-outline-primary" onClick={this.btnsave}>Save</button>
                                                        <button className="btn btn-block btn-outline-success" onClick={this.btnnew}>New</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <footer className="footer pt-3  ">
                                <div className="container-fluid">
                                    <div className="row align-items-center justify-content-lg-between">
                                        <div className="col-lg-6 mb-lg-0 mb-4">
                                            <div className="copyright text-center text-sm text-muted text-lg-start">
                                                © 2022,
                                                made with <i className="fa fa-heart" aria-hidden="true"/> by
                                                <a href="#" className="font-weight-bold"> ZTS Ethiopia</a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">ZTS Ethiopia</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link text-muted">About Us</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a href="#"
                                                       className="nav-link pe-0 text-muted">License</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        </div>
                    </main>
                </div>
            </>
        )
    }
}

export default TruckAllocation;
